"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historyMapFunctions = void 0;
exports.historyMapFunctions = {
    getNewestRevision: (history) => {
        return history[0];
    },
};
